import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Link } from 'react-router-dom';
const faqs = [{
  category: 'Michigan Specifics',
  questions: [{
    q: 'Which Yarbo is best for Michigan winters?',
    a: 'The Yarbo Snow Blower (or any bundle including the Snow Blower module) is designed specifically for heavy winter conditions. It uses a true 2-stage clearing mechanism that can handle up to 12 inches of snow and throws it efficiently, making it ideal for heavy, wet lake-effect snow common in Michigan.'
  }, {
    q: 'Can Yarbo handle steep slopes?',
    a: 'Yes. Both the Yarbo Lawn Mower and Lawn Mower Pro can handle slopes up to 35 degrees (70%). The tracks provide excellent traction, making it suitable for hilly lakefront properties or uneven rural terrain.'
  }]
}, {
  category: 'System & Modules',
  questions: [{
    q: 'Do I need the Yarbo Core?',
    a: 'Yes. The Yarbo Core is the central base unit that houses the battery, navigation, and drive system. All modules (Lawn Mower, Snow Blower, Leaf Blower) attach to the Core. You cannot use a module without the Core.'
  }, {
    q: 'What is the difference between Lawn Mower and Lawn Mower Pro?',
    a: 'The standard Lawn Mower is excellent for typical yards up to 6 acres. The Lawn Mower Pro features upgraded dual 300W motors and 2500W peak cutting power, making it better suited for demanding lawns, thicker grass, and tougher cutting conditions.'
  }, {
    q: 'Can I add modules later?',
    a: 'Absolutely. The Y Series is modular. You can start with a Lawn Mower system in the spring, and purchase just the Snow Blower module in the fall to attach to your existing Core.'
  }]
}, {
  category: 'Setup & Operation',
  questions: [{
    q: 'Do I need wires around my lawn?',
    a: 'No. Yarbo uses advanced RTK GPS and vision systems for wire-free navigation. You define virtual boundaries using the Yarbo smartphone app. This is especially beneficial in Michigan where frost heaves can break traditional buried perimeter wires.'
  }, {
    q: 'Can I schedule a demo?',
    a: 'Yes! As a local Michigan retailer, Merem Robotics offers demos and consultations. Please contact us to ask about demo availability in your specific area.'
  }]
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<string | null>('0-0');
  const toggleFAQ = (id: string) => {
    setOpenIndex(openIndex === id ? null : id);
  };
  return <div className="bg-white min-h-screen py-12 lg:py-20" data-id="element-260">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="text-center mb-16" data-id="element-262">
          <h1 className="text-4xl md:text-5xl font-extrabold text-yarbo-dark mb-6" data-id="element-263">
            Yarbo Michigan FAQ
          </h1>
          <p className="text-lg text-gray-600" data-id="element-264">
            Answers to common questions about Yarbo systems, modules, and
            operating in Michigan conditions.
          </p>
        </div>

        <div className="space-y-12" data-id="element-265">
          {faqs.map((section, sIdx) => <div key={sIdx} data-id="element-266">
              <h2 className="text-2xl font-bold text-yarbo-dark mb-6 pb-2 border-b border-gray-200" data-id="element-267">
                {section.category}
              </h2>
              <div className="space-y-4" data-id="element-268">
                {section.questions.map((faq, qIdx) => {
              const id = `${sIdx}-${qIdx}`;
              const isOpen = openIndex === id;
              return <div key={qIdx} className={`border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-yarbo-yellow bg-yellow-50/30' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-269">
                      <button onClick={() => toggleFAQ(id)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-270">
                        <span className="font-bold text-gray-900 pr-8" data-id="element-271">
                          {faq.q}
                        </span>
                        {isOpen ? <ChevronUp className="w-5 h-5 text-yarbo-yellow flex-shrink-0" data-id="element-272" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-273" />}
                      </button>

                      <AnimatePresence data-id="element-274">
                        {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-275">
                            <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-276">
                              {faq.a}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>;
            })}
              </div>
            </div>)}
        </div>

        <div className="mt-16 bg-yarbo-charcoal rounded-2xl p-8 text-center text-white" data-id="element-277">
          <h3 className="text-2xl font-bold mb-4" data-id="element-278">Still have questions?</h3>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-279">
            We're here to help you understand if Yarbo is the right fit for your
            property. Reach out to Merem Robotics for personalized advice.
          </p>
          <Link to="/contact" className="btn-primary" data-id="element-280">
            Contact Support
          </Link>
        </div>
      </div>
    </div>;
}